import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { makeClassesByStyles as l } from "../../../../../utils/classes.js";
import i from "../../../../../assets/abe99018.logo.png";
import a from "../../../../../assets/37c7ac08.loader.module.css";
const d = l(a), n = ({ className: s, type: r = "regular" }) => /* @__PURE__ */ t(
  "div",
  {
    className: d("Loader", `--${r}`, s),
    "aria-busy": "true",
    "aria-live": "polite",
    "data-testid": "loader",
    children: [
      r === "full-page" && /* @__PURE__ */ o(
        "img",
        {
          className: a.logo,
          itemProp: "logo",
          src: i,
          alt: "logo",
          height: "32",
          width: "132"
        }
      ),
      /* @__PURE__ */ o("div", { className: a.dots, "data-testid": "loader-dots", children: Array(4).fill("").map((m, e) => /* @__PURE__ */ o("span", { className: a.dot }, e)) })
    ]
  }
);
export {
  n as Loader
};
